"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var schema_1 = require("../../core/schema");
var bridge_1 = require("../../core/bridge");
var prompt_1 = require("../../core/prompt");
var app_1 = require("../../base/app");
var passengerConfig = {
    android: {
        factory: prompt_1.default,
        options: {
            bridgeCallbackName: '__bridgeCall__'
        }
    },
    ios: {
        factory: schema_1.default,
        options: {
            bridgeSchema: 'didibridge://BRIDGE_CALL?callback=',
            bridgeCallDataName: '__getCallData__',
            bridgeCallbackName: '__bridgeCall__'
        }
    },
    compatible: {
        factory: bridge_1.default,
        options: {
            bridgeName: 'DidiJSBridge',
            bridgeEvent: 'DidiJSBridgeReady'
        },
        hit: function (app) {
            return app_1.compareAppVersion(app.version, '<', '5.0.0');
        }
    }
};
exports.passenger = passengerConfig;
exports.default = passengerConfig;
